export const ModalLayout = ({ children }) => {
    return <div className="modalLayout">{children}</div>;
  };
  